import { notifyPartnerServicesClick } from '@/utils/notifyPartnerServicesClick'

export const OPEN_PARTNER_SERVICES_EVENT = 'coolliving:open-partner-services'

/** Abre PartnerContactModal (misma UX que PartnerServicesSection). */
export function openPartnerServicesModal({
  source = 'app',
  serviceKey = 'marketplace',
  user = null,
} = {}) {
  notifyPartnerServicesClick(source, user)
  if (typeof window === 'undefined') return
  window.dispatchEvent(
    new CustomEvent(OPEN_PARTNER_SERVICES_EVENT, {
      detail: { serviceKey },
    }),
  )
}
